import { render, staticRenderFns } from "./FeedData.vue?vue&type=template&id=159ddf4c&scoped=true&"
import script from "./FeedData.vue?vue&type=script&lang=js&"
export * from "./FeedData.vue?vue&type=script&lang=js&"
import style0 from "./FeedData.vue?vue&type=style&index=0&id=159ddf4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ddf4c",
  null
  
)

export default component.exports